<template>
    <section class="event-add-student-view">
        <h3>Add Students To Event</h3>

        <div class="envelop">
            <app-select v-model="type" placeholder="Select">
                <app-option label="Individual" value="student"/>
                <app-option label="Team" value="team"/>
            </app-select>
            <label v-if="type == 'student'">
                <span class="visuallyhidden">Name or Email</span>
                <app-input 
                    v-model="queries.student" 
                    placeholder="Name or Email"
                    autofocus />
            </label>
            <label v-else>
                <span class="visuallyhidden">Team Name</span>
                <app-input 
                    v-model="queries.team" 
                    placeholder="Team Name"
                    autofocus/>
            </label>
        </div>
        <div v-if="type == 'student'" class="students">
            <app-alert>Search for individual students and click to add them to the event.</app-alert>
            <student-table
                :items="students"
                :columns="['first_name','last_name','email']"
                :allow-sort="false"
                :handle-click="handleAddStudent"/>
        </div>
        <div v-if="type == 'team'" class="teams">
            <app-alert>Search for teams and click to add their current students to the event.</app-alert>
            <team-table :items="teams" :allow-sort="false" :handle-click="handleAddTeam"/>
        </div>
    </section>
</template>
<script>
import StudentTable from '../Student/StudentTable'
import TeamTable from '../Team/TeamTable'
import Student from '@/store/models/Student'
import Team from '@/store/models/Team'
import Event from '@/store/models/Event'

export default {
    name: 'event-add-student-view',
    inject: ['modalOptions'],
    components: {
        StudentTable,
        TeamTable
    },
    props: ['event'],
    data() {
        return {
            students: [],
            teams: [],
            queries: {
                student: '',
                team: ''
            },
            type: 'student',
            loading: false
        }
    },
    methods: {
        getStudentList(query) {
            this.loading = true
            Student.$search({ query })
                .then(students => {
                    this.loading = false
                    this.students = students
                })
        },
        getTeamList(query) {
            this.loading = true
            Team.$search(query).then(teams => {
                this.loading = false
                this.teams = teams
            })
        },
        handleAddStudent(student) {
            const name = student.first_name + ' ' + student.last_name
            this.event.$attach(
                student.id, 
                'students', 
                'addStudentToEvent', 
                true
            )
                .then(() => {
                    this.$notify({
                        title: 'Success',
                        message: name + ' added to the event.',
                        type: 'success',
                        offset: 75,
                        duration: 5000
                    })
                    this.$emit('reload')
                })
            return false
        },
        handleAddTeam(team) {
            if (this.loading) return
            this.loading = true
            Event.$mutate({
                graphql: 'addTeam',
                variables: {
                    event_id: this.event.id,
                    team_id: team.id
                }
            }).then(() => {
                this.loading = false
                this.$notify({
                    title: 'Success',
                    message:
                        'The students in ' +
                        team.name +
                        ' have been added to the event.',
                    type: 'success',
                    offset: 75,
                    duration: 5000
                })
                this.$emit('reload')
                this.modalOptions.modalOpen = false
            })

            return false
        },
        showSwapDialog(student, message) {
            this.$confirm({
                title: 'Confirm',
                message: message
            }).then(() => {
                this.handleAddStudent(student, true)
            })
        }
    },
    watch: {
        'queries.student': function(newValue) {
            this.getStudentList(newValue)
        },
        'queries.team': function(newValue) {
            this.getTeamList(newValue)
        }
    }
}
</script>

<style lang="stylus">
.envelop
    display: flex

    .app-select
        flex-grow: 0

        input
            border-radius: 5px 0px 0px 5px

    label
        flex-grow: 1
        width: 100%
        margin-left: -1px

        input
            border-radius: 0px 5px 5px 0px
</style>
